import { withRouter } from 'react-router-dom';
import React, { Component } from "react";
import "./../../Grid.css";
import "./../../Form.css";
import "./../../App.css";
import { ViewContainer } from "../../View.jsx";
import ViewUtils from '../../ViewUtils';
import EnhancedToolbar from '../../widgets/Toolbar';
import EnhancedTable from '../../widgets/ResponsiveTable';
import AlertItem from "../../widgets/AlertItem";
import EditDialog from './OrganisationSDFEditDialog';
import withMenuPermission from "../../widgets/withMenuPermission";
import DocumentModal from '../../widgets/DocumentViewerV2.jsx';
import { OrganisationSDFUploadForm } from './OrganisationSDFUploadForm';
import FormDialog from "../../etqa/FormDialog";
import Prompt from '../../widgets/Prompt';

const utils = new ViewUtils();
const toolbarRef = React.createRef();
const addFormRef = React.createRef();

const headCells = [
    { id: 'FirstName', numeric: false, disablePadding: true, label: 'First Name' },
    { id: 'Surname', numeric: false, disablePadding: true, label: 'Surname' },
    { id: 'Email', numeric: false, disablePadding: true, label: 'Email' },
    { id: 'CellPhoneNumber', numeric: false, disablePadding: true, label: 'Cellphone Number' },
    { id: 'StartDate', numeric: false, disablePadding: true, label: 'Start Date' },
    { id: 'EndDate', numeric: false, disablePadding: true, label: 'End Date' },
    { id: 'Status', numeric: false, disablePadding: true, label: 'SDF Status' },
    { id: 'Role', numeric: false, disablePadding: true, label: 'SDF Role' },
    { id: 'Document', numeric: false, disablePadding: true, label: 'Letter of Appointment', contentType: 'document' },
    { id: 'IDCopy', numeric: false, disablePadding: true, label: 'ID Copy', contentType: 'document' },
];

class OrganisationSDF extends Component {
    constructor(props) {
        super(props);
        this.state = {
            model: {
                Id: this.props.location.state.selection
            },
            addDialogOpen: false,
            editDialogOpen: false,
            selectedId: null,
            searchParameters: [{ Name: "OrganisationID", Value: this.props.location.state.organisationID }],
            clearSelectedRow: false,
            isOpen: false,
            base64: null,
            name: null,
            type: null,
            showTable: true,
            promptOpen: false,
            promptTitle: "Remove Document",
            promptContent: "Are you sure you want to remove this Document?",
            removeURL: null,
        }

        this.toolbarConfig = {
            items: [

                {
                    type: "buttonGroup",
                    buttons: [
                        { id: 'close', label: 'CLOSE', tooltip: 'Close', icon: 'CloseIcon' }
                    ]
                }
                ,
                {
                    type: "devider"
                },

                {
                    type: "buttonGroup",
                    buttons: [
                        { id: 'edit', label: '', tooltip: 'Change Role/Status', disabled: utils.isNull(this.state.selectedId), icon: 'EditIcon', visible: this.props.menuPermissionItem.Edit },
                        { id: 'add', label: '', tooltip: 'Upload Document', disabled: utils.isNull(this.state.selectedId), icon: 'UploadIcon', visible: this.props.menuPermissionItem.Add },
                        { id: 'deleteLOA', label: 'Remove Letter of Appointment', tooltip: 'Remove Document', disabled: utils.isNull(this.state.selectedId), visible: this.props.menuPermissionItem.Delete },
                        { id: 'deleteIDCopy', label: 'Remove ID Copy', tooltip: 'Remove Document', disabled: utils.isNull(this.state.selectedId), visible: this.props.menuPermissionItem.Delete }
                    ]
                }
            ]
        }
    }


    handleToolbarButtonClick = (buttonId) => {
        if (buttonId === "edit") {
            this.setState({ editDialogOpen: true });
        }
        else if (buttonId === "add") {
            this.setState({ addDialogOpen: true });
        }
        else if (buttonId === "deleteLOA") {
            this.setState({ promptOpen: true,removeURL: "api/sims/OrganisationSDF/RemoveLOADocument" });
        }
        else if (buttonId === "deleteIDCopy") {
            this.setState({ promptOpen: true,removeURL: "api/sims/OrganisationSDF/RemoveIDCopyDocument" });
        }
        else if (buttonId === "close") {
            this.props.history.push({
                pathname: "/skillsOrganisation",
                state: { selection: this.props.location.state.organisationID }
            })
        }
        else {
            // this.setState({ editDialogOpen: true });
        }
    }

    handleFormValueChange(values) {

        let newsearchParameters = [...this.state.searchParameters];

        this.setState({
            searchParameters: JSON.parse(JSON.stringify(newsearchParameters)),
        });
    }

    handleSelectionChange = (selection) => {
        console.log(selection);
        if (selection !== null && selection.length !== 0) {
            this.setState({ selectedId: selection[0].Id, Message: "", clearSelectedRow: false });
        } else {
            this.setState({ selectedId: null, clearSelectedRow: false });
        }
        toolbarRef.current.setButtonDisabled("edit", selection === null || selection.length === 0);
        toolbarRef.current.setButtonDisabled("add", selection === null || selection.length === 0);
        toolbarRef.current.setButtonDisabled("deleteLOA", selection === null || selection.length === 0 || utils.isNull(selection[0].OriginalFileName) || selection[0].OriginalFileName === "");
        toolbarRef.current.setButtonDisabled("deleteIDCopy", selection === null || selection.length === 0 || utils.isNull(selection[0].IDCopy) || selection[0].IDCopy === "");
    }

    postAddHandler(cancel, save, response) {
        if (save === true) {
            console.log(response)
            if (response.MessageType === "SUCCESS") {
                this.setState({
                    searchParameters: JSON.parse(JSON.stringify(this.state.searchParameters)),
                    editDialogOpen: false,
                    selectedId: null,
                    Message: response.Message,
                    MessageStyle: "success",
                    clearSelectedRow: true
                });
                toolbarRef.current.setButtonDisabled("remove", true);
            }
            else {
                this.setState({
                    searchParameters: JSON.parse(JSON.stringify(this.state.searchParameters)),
                    editDialogOpen: false,
                    selectedId: null,
                    Message: response.Message,
                    MessageStyle: response.MessageType
                });
            }
        }
        else if (cancel === true) {
            this.setState({
                editDialogOpen: false,
                selectedId: null,
                clearSelectedRow: true
            })
        }
        toolbarRef.current.setButtonDisabled("edit", true);
        toolbarRef.current.setButtonDisabled("add", true);
        toolbarRef.current.setButtonDisabled("deleteLOA", true);
        toolbarRef.current.setButtonDisabled("deleteIDCopy", true);
    }

    postAddDocHandler(cancel, save) {
        if (save === true) {
                this.setState({
                    searchParameters: JSON.parse(JSON.stringify(this.state.searchParameters)),
                    addDialogOpen: false,
                    selectedId: null,
                    clearSelectedRow: true
                });
        }
        else if (cancel === true) {
            this.setState({
                addDialogOpen: false,
                selectedId: null,
                clearSelectedRow: true
            })
        }
        toolbarRef.current.setButtonDisabled("edit", true);
        toolbarRef.current.setButtonDisabled("add", true);
        toolbarRef.current.setButtonDisabled("deleteLOA", true);
        toolbarRef.current.setButtonDisabled("deleteID", true);
    }

    closePrompt = () => {
        this.setState({ promptOpen: false, clearSelectedRow: true, selectedId: null })
    }

    closeDocumentModal = () => {
        this.setState({ base64: null,isOpen: false,message: "",MessageStyle: ""  })
    }

    onClearSelectedRow = () => {
        this.setState({ clearSelectedRow: false,Message: "",MessageStyle: ""  });
    }

    FileDownload = (rowid, headCell) => {
        this.setState({ Message: "",MessageStyle: "" })
        if (headCell.id === "Document") {
            utils.invokeUrl("api/sims/OrganisationSDF/downloaddocument?id=" + rowid, (response) => {

            this.setState({
                    isOpen: true,
                    base64: response.Base64, 
                    name: response.Name,
                    type: response.Type
                        })
            }, (e) => {
                this.setState({ Message: "File Not Found", MessageStyle: "ERROR" });
            }
            );
        }
        else if (headCell.id === "IDCopy") {

            utils.invokeUrl("api/sims/OrganisationSDF/downloadIDCopy?id=" + rowid, (response) => {

                this.setState({
                    isOpen: true,
                    base64: response.Base64, 
                    name: response.Name,
                    type: response.Type
                        })
            }, (e) => {
                this.setState({ Message: "File Not Found", MessageStyle: "ERROR" });
            }
            );
        }
    };

    base64ToArrayBuffer(base64) {
        var binary_string = window.atob(base64);
        var len = binary_string.length;
        var bytes = new Uint8Array(len);
        for (var i = 0; i < len; i++) {
            bytes[i] = binary_string.charCodeAt(i);
        }
        return bytes.buffer;
    };

    remove(url) {
        this.setState({ promptOpen: false, clearSelectedRow: true, selectedId: null }, () => {
            toolbarRef.current.setButtonDisabled("remove", true);
        })

        let fullUrl = `${url}?id=${this.state.selectedId}`;
        utils.invokeUrlDelete(fullUrl, this.successfulRemoveCallback, this.unsuccessfulRemoveCallback);
    }
    
    successfulRemoveCallback = (response) => {

        if (!utils.isNull(response.EntityId) && response.EntityId === 0) {
            this.setState({
                selectedId: null, Message: response.Message, MessageStyle: response.MessageType.toLowerCase(),
                clearSelectedRow: true
            });
            //Force a refresh
            this.setState({ searchParameters: JSON.parse(JSON.stringify(this.state.searchParameters)) })
        }
    }

    unsuccessfulRemoveCallback = (response) => {
        if (!utils.isNull(response.Message) && response.Message !== "") {
            this.setState({ Message: response.Message, MessageStyle: response.MessageType.toLowerCase() })
        }
    }

    render() {
        return (
            <ViewContainer mode={this.props.mode} title="">
                <p className="legend">
                    {"Organisation > SDF " + (this.props.location.state.organisationName !== null ? "> " + this.props.location.state.organisationName + (this.props.location.state.sdlnumber !== null ? " - " + this.props.location.state.sdlnumber : "") : "> Add")}
                </p>

                <AlertItem message={this.state.Message} alertStyle={this.state.MessageStyle} />

                <div className="searchResults">

                    <EnhancedToolbar highlight={false}
                        title="Organisation SDF"
                        buttonClickHandler={(buttonId) => this.handleToolbarButtonClick(buttonId)}
                        ref={toolbarRef}
                        config={this.toolbarConfig}
                    />

                    <EnhancedTable
                        headCells={headCells}
                        onSelectionChange={(selection) => { this.handleSelectionChange(selection) }}
                        dataUrl="api/sims/OrganisationSDF/GetSearch"
                        searchParameters={this.state.searchParameters}
                        clearSelectedRow={this.state.clearSelectedRow} onClearSelectedRow={this.onClearSelectedRow}
                        onCellSelectionChange={(rowid, headCell) => { this.FileDownload(rowid, headCell) }}
                        paged={true} />
                </div>

                <EditDialog
                    open={this.state.editDialogOpen}
                    id={this.state.selectedId}
                    closeHandler={(cancel, save, response) => this.postAddHandler(cancel, save, response)}
                    viewRef={this}
                />
                <DocumentModal 
                    isOpen={this.state.isOpen}
                    onClose={() => this.closeDocumentModal()}
                    base64Data={this.state.base64}
                    fileName={this.state.name}
                    fileType={this.state.type}
                />
                <FormDialog
                    open={this.state.addDialogOpen}
                    dialogTitle={"Upload"}
                    viewRef={this}
                    entityInfo={{ SDFOrganisationID: this.state.selectedId }}
                    formRef={addFormRef}
                    saveUrl={"api/sims/organisationsdf/AddOrganisationSDFDocument"}
                    usePost={true}
                    closeHandler={(cancel, save) => this.postAddDocHandler(cancel, save)}
                    IsExternal={this.state.IsExternal}
                >
                    <OrganisationSDFUploadForm ref={addFormRef} valueChangeHandler={(values) => this.handleFormValueChange(values)} open={this.state.addDialogOpen} SDFOrganisationID={this.state.selectedId}
                    />
                </FormDialog>                                


                <Prompt open={this.state.promptOpen}
                    promptTitle={this.state.promptTitle}
                    promptContent={this.state.promptContent}
                    handleYes={() => { this.remove(this.state.removeURL) }}
                    closePrompt={this.closePrompt}
                />
            </ViewContainer>
        );
    }
}

export default withRouter(withMenuPermission(OrganisationSDF));